import React, { useEffect, useState } from "react";
import "./AllPatients.css";
import { FaSquare } from "react-icons/fa";
import { getPatients } from "../../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../../Common/Component/CustomPagination/CustomPagination";
import { useNavigate } from "react-router-dom";
import Loader from "../../../utils/Loader";
import { useSelector } from "react-redux";

const AllPatients = () => {
  /* Declaration's */
  const data = useSelector((state) => state.login?.data);
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const colors = [
    "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    "#e9c183", // light Orange
  ];

  const getColorForScore = (score) => {
    if (score >= 0 && score <= 3) {
      return "#BDE7BD"; // Light Green
    } else if (score >= 4 && score <= 6) {
      return "#FFF8B8"; // Pale Yellow
    } else if (score >= 7 && score <= 10) {
      return "#FFB6B3"; // Light Coral Pink
    } else {
      return "#BDE7BD"; // Default Grey for invalid scores
    }
  };

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchPatients();
  }, [page, limit]);

  const fetchPatients = async () => {
    try {
      setLoading(true);

      const response = await getPatients({
        page: page + 1,
        limit,
        searchKey: searchText,
      });
      if (response?.status === "SUCCESS") {
        setLoading(false);

        setPatients(response?.data?.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Please try again later");
    }
  };

  const redirectToProfile = (provider) => {
    data.role === "DOCTOR" &&
      navigate("/doctor/patient", { state: { patient: provider } });
    data.role === "ADMIN" &&
      navigate("/admin/patient", { state: { patient: provider } });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="table-responsive dashboard-table">
            <table className="patients-table">
              <thead>
                <tr className="t-row-block">
                  <th scope="col"></th>
                  <th scope="col">Patient Name</th>
                  <th scope="col">ICBPS</th>
                  <th scope="col">Gender</th>
                  <th scope="col">Date Of Birth</th>
                  <th scope="col">Mobile Number</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                {patients.length > 0 ? (
                  patients.map((patient, index) => (
                    <tr key={patient.id || index}>
                      <td scope="row">
                        <FaSquare
                          className="score-box"
                          style={{
                            color: getColorForScore(patient?.icbps),
                          }}
                        />
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => redirectToProfile(patient)}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="patientlist-img">
                            {patient?.photoUrl ? (
                              <img src={patient.photoUrl} alt="patient-img" />
                            ) : (
                              <div
                                className="patient-initials"
                                style={{
                                  background: colors[index % colors.length],
                                }}
                              >
                                {`${patient?.firstName?.[0] || ""}${patient?.lastName?.[0] || ""
                                  }`.toUpperCase()}
                              </div>
                            )}
                          </div>
                          <span
                            className="text-capitalize "
                            style={{ cursor: "pointer" }}
                          >
                            {patient?.firstName ? patient?.firstName : "-"}{" "}
                            {patient?.lastName ? patient?.lastName : ""}
                          </span>
                        </div>
                      </td>

                      <td>{patient?.icbs ? patient?.icbs : "-"}</td>
                      <td>{patient?.gender ? patient?.gender : "-"}</td>
                      <td>
                        {patient?.birthDate
                          ? patient?.birthDate?.split("T")[0]
                          : "-"}
                      </td>
                      <td>{patient?.phone ? patient?.phone : "-"}</td>
                      <td>{patient?.email ? patient?.email : "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Patients Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-blk">
            <CustomPagination
              totalItems={totalItems}
              page={page}
              onPageChange={handleChangePage}
              limit={limit}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AllPatients;
